import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CdkTableModule } from '@angular/cdk/table';
import { CaPaginationComponent } from '@global-front-components/ui/pagination';
import { CaResizeColumnDirective } from '@global-front-components/common/resize-column';
import { ColumnasTabla } from '../../model/tabla-seguros.model';
import { CaButtonComponent } from '@global-front-components/ui/button';
import { CaMenuComponent, CaMenuDirective, CaMenuItemComponent } from '@global-front-components/ui/menu';

@Component({
	selector: 'ca-tabla-seguros',
	standalone: true,
	imports: [
		CommonModule,
		TranslateModule,
		CdkTableModule,
		CaPaginationComponent,
		CaResizeColumnDirective,
		CaMenuComponent, 
		CaMenuDirective, 
		CaMenuItemComponent,
		CaButtonComponent
	],	templateUrl: './tabla-seguros.component.html',
	styleUrls: ['./tabla-seguros.component.scss']
})
export class CaTablaSegurosComponent implements OnInit{
	@Input() paginado!: boolean;
	@Input() registroSeleccionable!: boolean;
	@Input() tamanoPagina!: number;
	@Input() columnas: ColumnasTabla[];
	@Input() registros: any[];
	@Input() mostrarContratar: boolean = false;
	@Input() mostrarGuardar: boolean = false;

	mostrarMenuAcciones: boolean = false;
	@Output() registroSeleccionadoEvent = new EventEmitter<any>();
	@Output() guardarEvent = new EventEmitter<any>();
	@Output() contratarEvent = new EventEmitter<any>();

	public registroSeleccionado: any;	
	public columnasMostradas: string[] = [];
	public tamanoDatos: number;
	public datosTablaMostrados: any[] = [];
	public pagina = 1;

	private _preventSingleClick = false;

	ngOnInit(): void {
		this.setColumnasMostradas();
		this.datosTablaMostrados = this.registros;
		this.tamanoDatos = this.datosTablaMostrados?.length || 1;
		this.paginate();

	}

	paginate(): void {
		this.datosTablaMostrados = this.registros?.slice((this.pagina - 1) * this.tamanoPagina, (this.pagina - 1) * this.tamanoPagina + this.tamanoPagina);
	}

	private setColumnasMostradas(): void {
		if (this.mostrarContratar || this.mostrarGuardar) {
			this.columnas.push({
				id: this.columnas.length + 1,
				field: 'acciones',
				value: '',
			})
		}

		this.columnasMostradas = this.columnas.map((column) => column.field);
	}

	isSelectedRow(row): boolean {
		return this.registroSeleccionado && Object.keys(this.registroSeleccionado).every((key) => this.registroSeleccionado[key] === row[key]);
	}

	onSelectedRow(row: any): void {
		this._preventSingleClick = false;

		setTimeout(() => {
			if (this._preventSingleClick) {
				return;
			}

			if (!this.isSelectedRow(row)) {
				this.registroSeleccionado = row;
				this.registroSeleccionadoEvent.emit(this.registroSeleccionado);
			}
		}, 100);
	}
	
	emitirGuardar(row): void {
		this.guardarEvent.emit(row);
	}

	emitirContratar(row): void {
		this.contratarEvent.emit(row);
	}
}
